<dx-data-grid #grid (editorComponentClosed)="editorComponentClosed()" *ngIf="seasonalities" [glamResource]="seasonalities!" class="flex-1" #gridWarehouses
[createComponent]="createProductWarehouseComponent" [customParams]="{id: product!.id}">
<dxi-column dataField="warehouseId" [caption]="'entity.product.warehouse' | translate | ucfirst"
  [allowEditing]="true">
  <dxi-validation-rule type="required" />
  <dxo-lookup [dataSource]="warehouses" displayExpr="name" valueExpr="id" />
</dxi-column>
<dxi-column dataField="seasonalityId" [caption]="'entity.product.seasonalityId' | translate | ucfirst"
  [allowEditing]="true">
  <dxi-validation-rule type="required" />
  <dxo-lookup [dataSource]="companySeasonalities" displayExpr="name" valueExpr="id" />
</dxi-column>
<dxi-column dataField="minStock" dataType="number" [allowEditing]="true"
  [caption]="'entity.product.minStock' | translate | ucfirst" />
  <dxi-column dataField="maxStock" dataType="number" [allowEditing]="true"
  [caption]="'entity.product.maxStock' | translate | ucfirst" />
  <dxi-column dataField="securityStock" dataType="number" [allowEditing]="true"
  [caption]="'entity.product.securityStock' | translate | ucfirst" />
  <dxi-column dataField="optimalOrderAmount" dataType="number" [allowEditing]="true"
  [caption]="'entity.product.optimalOrderAmount' | translate | ucfirst" />
  <dxi-column cssClass="calculated-cell" dataField="ratios.optimalStock" dataType="number" [allowEditing]="false"
  [caption]="'entity.product.optimalStock' | translate | ucfirst" />
  <dxi-column cssClass="calculated-cell" dataField="ratios.justInTime" dataType="number" [allowEditing]="false"
  [caption]="'entity.product.justInTime' | translate | ucfirst" />
  <dxi-column cssClass="calculated-cell" dataField="ratios.optimalBatch" dataType="number" [allowEditing]="false"
  [caption]="'entity.product.optimalBatch' | translate | ucfirst" />
</dx-data-grid>